import { apiPost } from './client';

export type SubmitIntakeResponse = {
  intake_id: string;
  monday_item_id: string | null;
  monday_synced: boolean;
  already_submitted: boolean;
  submitted_at: string;
};

export function submitIntake(sessionId: string): Promise<SubmitIntakeResponse> {
  return apiPost<SubmitIntakeResponse>('/api/intakes/submit', {
    session_id: sessionId,
  });
}
